import { Grid } from "@material-ui/core";
import BPago from "./BPagos";
import TPagos from "./TPagos";
import Depositos from "../../Reportes/Depositos";
export default function VPagoUnico() {
  return (
    <>
      <Grid container alignItems="center" >
        <Grid item xs={12}>
          <BPago />
        </Grid>
        <Grid item xs={12}>
          <TPagos />
        </Grid>
      </Grid>
      <Depositos />
    </>
  )
}
